/**
 * @fileoverview Agent definition for story-modifier-v1.
 *
 * Takes a natural language change request from the author and applies
 * modifications across storylines, character arcs, and writtenPlot.
 * Results are shown for user confirmation before persisting (Tier 2).
 *
 * @category narrative.story.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'story-modifier-v1',
  kind: 'primitive',
  name: 'Story Modifier',
  description: 'Applies natural language change requests across storylines, character arcs, and writtenPlot. Returns proposed changes with commentary for user confirmation before persisting.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.planning',
    usedBy: [
      'primitives/use-story-modifier-v1.ts',
    ],
    relatedAgents: [
      'written-plot-refresher-v1',
      'storyline-refresher-v2',
      'character-arc-refresher-v1',
      'plot-planner-v1',
    ],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-sonnet-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
